import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Single-page apps keep the window scroll position when the route changes, so
 * opening a product from halfway down the products grid used to land you
 * halfway down the product page. This resets to the top on every forward
 * navigation. Back/forward (POP) is left alone so the browser can restore the
 * position the visitor was at.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, search, navigationType]);

  return null;
};

export default ScrollToTop;
